import { render, staticRenderFns } from "./create-support.component.html?vue&type=template&id=e90d57a2&scoped=true&external"
import script from "./create-support.component.ts?vue&type=script&lang=ts&external"
export * from "./create-support.component.ts?vue&type=script&lang=ts&external"
import style0 from "./create-support.component.scss?vue&type=style&index=0&id=e90d57a2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90d57a2",
  null
  
)

export default component.exports